import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Observable, of, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Card, CardResponse, CardViz, ProductionData, Well } from "../models/well.model";
import { LoggerService } from "./logger.service";

const mockIVAAPResponses =  [
    {
        "dashboard_id": "97fe1ce6-b68c-4757-bbb4-0ca7e626c0c7",
        "desc": "3D Visualization with all data and a map",
        "ivaap_url": [
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Aceba16fb-6109-4f5a-b91e-c26bd1421794%22%7D%5D%7D",
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A87129e56-d617-43e6-9f10-3fa4b2bbdcc9%22%7D%5D%7D",
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A3e102263-cf47-4a3c-83a9-be6c587abcd3%22%7D%5D%7D",
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ace7758d3-9944-4600-87a7-e503246154dd%22%7D%5D%7D",
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ade813c76-7a3f-4236-8ca4-a8c7e98f1fd1%22%7D%5D%7D",
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ac718e23c-ab1c-429a-8f0c-ab9c65987f25%22%7D%5D%7D",
            "IVAAPMiddleTier:///ivaap/api/ds/blobstorage/v1/sources/37a2ae7d-9cdb-4c90-81ff-80d30909143b/reservoirs/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22containerName%22%2C%22value%22%3A%22adme%22%7D%2C%7B%22name%22%3A%22objectName%22%2C%22value%22%3A%223DGrid_GRDECL%2FOkan_3DModel.GRDECL%22%7D%5D%7D",
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/seismic/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Awork-product-component--SeismicTraceData%3A43041ea5-74b7-4e9a-a22f-96f6b1e0027c%22%7D%5D%7D"
        ],
        "type": "template"
    },
    {
        "dashboard_id": "173556b2-c3ef-46d2-9897-99f4ed1c658e",
        "desc": "OK-53 Production Complete (Dashboard)",
        "ivaap_url": [],
        "type": "dashboard"
    },
    {
        "dashboard_id": "84cfde09-701b-4c9a-b331-9a4f80ff960a",
        "desc": "Strat column OKA-53",
        "ivaap_url": [
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A3e102263-cf47-4a3c-83a9-be6c587abcd3%22%7D%5D%7D"
        ],
        "type": "template"
    },
    {
        "dashboard_id": "807ce95e-7876-4862-89b6-ce1bc01551a7",
        "desc": "Triple Combo Complete",
        "ivaap_url": [
            "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A3e102263-cf47-4a3c-83a9-be6c587abcd3%22%7D%5D%7D"
        ],
        "type": "template"
    }
]
@Injectable({
  providedIn: "root",
})
export class WellService {
  private apiUrl = environment.apiEndpoint + "/wells";

  loadedWells: Well[] = [];

  snackbar = inject(MatSnackBar);

  currentExample = 0;

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    });
  }

  getWells(): Observable<Well[]> {
    this.logger.info("Fetching wells from w API");
    return this.http
      .get<Well[]>(`${this.apiUrl}/wells`, {
        headers: this.getHeaders(),
      })
      .pipe(
        map((wells) =>
          wells.map((w) => ({
            ...w,
            // ivaapTemplateId:
            //   "ivaap-dashboard-provider::71d15876-12a9-4768-8dce-c4016c51bb4d",
            // ivaapDatasetIds: [
            //   // 20
            //   "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Aceba16fb-6109-4f5a-b91e-c26bd1421794%22%7D%5D%7D",
            //   // 30
            //   "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A87129e56-d617-43e6-9f10-3fa4b2bbdcc9%22%7D%5D%7D",
            //   // 53
            //   "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A3e102263-cf47-4a3c-83a9-be6c587abcd3%22%7D%5D%7D",
            //   //77
            //   "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ace7758d3-9944-4600-87a7-e503246154dd%22%7D%5D%7D",
            //   //82
            //   "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ade813c76-7a3f-4236-8ca4-a8c7e98f1fd1%22%7D%5D%7D",
            //   //83
            //   "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ac718e23c-ab1c-429a-8f0c-ab9c65987f25%22%7D%5D%7D",

            //   "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/seismic/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Awork-product-component--SeismicTraceData%3A43041ea5-74b7-4e9a-a22f-96f6b1e0027c%22%7D%5D%7D",
            // ],
          })),
        ),
        tap((wells) => {
          this.loadedWells = wells;
        }),
        catchError((error) => {
          this.logger.error("Error fetching wells", error);
          this.showMessage("Failed to load wells. Using sample data.");
          return throwError(() => error); //     {
        }),
      );
  }

  getWellById(id: string): Observable<Well> {
    this.logger.info(`Fetching well with id: ${id}`);
    return this.http
      .get<Well>(`${this.apiUrl}/wells/${id}`, {
        headers: this.getHeaders(),
      })
      .pipe(
        tap((well) => this.logger.info(`Retrieved well: ${well.name}`)),
        catchError((error) => {
          this.logger.error(`Error fetching well ${id}`, error);
          return throwError(() => error);
        }),
      );
  }

  getProductionData(
    wellId: string,
    type: string,
  ): Observable<ProductionData[]> {
    this.logger.info(`Fetching ${type} production data for well ${wellId}`);
    return this.http
      .get<ProductionData[]>(`${this.apiUrl}/production/${wellId}/${type}`, {
        headers: this.getHeaders(),
      })
      .pipe(
        tap((data) =>
          this.logger.info(`Retrieved ${data.length} production records`),
        ),
        catchError((error) => {
          this.logger.error(`Error fetching production data`, error);
          return throwError(() => error);
        }),
      );
  }

  getInteractiveViewer(wellId: string): Observable<any> {
    this.logger.info(`Fetching interactive viewer for well ${wellId}`);
    return this.http
      .get(`${this.apiUrl}/viewer/${wellId}`, {
        headers: this.getHeaders(),
      })
      .pipe(
        catchError((error) => {
          this.logger.error(`Error fetching interactive viewer`, error);
          return throwError(() => error);
        }),
      );
  }

  getSeismicData(wellId: string): Observable<any> {
    this.logger.info(`Fetching seismic data for well ${wellId}`);
    return this.http
      .get(`${this.apiUrl}/seismic/${wellId}`, {
        headers: this.getHeaders(),
      })
      .pipe(
        catchError((error) => {
          this.logger.error(`Error fetching seismic data`, error);
          return throwError(() => error);
        }),
      );
  }

  getDrillingData(wellId: string): Observable<any> {
    this.logger.info(`Fetching drilling data for well ${wellId}`);
    return this.http
      .get(`${this.apiUrl}/drilling/${wellId}`, {
        headers: this.getHeaders(),
      })
      .pipe(
        catchError((error) => {
          this.logger.error(`Error fetching drilling data`, error);
          return throwError(() => error);
        }),
      );
  }

  getCard(entityId: string, entityType: string = 'Well'): Observable<Card> {
    const params: { [key: string]: string } = {};
    if (entityType === 'Well') {
      params['well_name'] = entityId;
    }
    const wellResponse =  this.http.get<CardResponse>(`${this.apiUrl}/cards`, {
      headers: this.getHeaders(),
      params: params,
    }).pipe(
      map(response => response.results),
      catchError((error) => {
        this.logger.error(`Error fetching cards for ${entityId}`, error);
        this.showMessage(`Failed to load cards for ${entityId}`);
        return of(); // Return empty array on error
      }),
    );

    //Mocks
    this.logger.info(`Returning mocked cards for ${entityId} of type ${entityType}`);
    const mockCards: Card = {
      title: `Mocked Card for ${entityId}`,
      type: "mock",
      id: `${entityId}-card`,
      data: [
        {
          type_id: "Production Data",
          osdu_id: "prod-data-123",
        },
        {
          type_id: "Drilling Data",
          osdu_id: "drill-data-456",
        },
        {
          type_id: "Seismic Data",
          osdu_id: "seismic-data-789",
        }
      ]
    }

    if (entityType === 'Well') {
      return wellResponse;   
    }
    return of(mockCards);
  }

  getCardDetails(cardId: string): Observable<CardViz> {
    // Commented out actual endpoint
    // return this.http.post<Card>(`${this.apiUrl}/card-details`, { cardId }, { headers: this.getHeaders() }).pipe(
    //   catchError((error) => {
    //     this.logger.error(`Error fetching details for card ${cardId}`, error);
    //     this.showMessage(`Failed to load details for card ${cardId}`);
    //     return of({
    //       title: "Error",
    //       type: "error",
    //       id: cardId,
    //       data: [],
    //     } as Card); // Return error card on failure
    //   }),
    // );

    // // Return mocked data with viz attribute populated
    // this.logger.info(`Returning mocked card details for ${cardId}`);
    // const mockCardViz: CardViz = {
    //   viz: {
    //     dashboard_id:
    //       "ivaap-dashboard-provider::84cfde09-701b-4c9a-b331-9a4f80ff960a",
    //     ivaap_url: [
    //           // 20
    //           "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Aceba16fb-6109-4f5a-b91e-c26bd1421794%22%7D%5D%7D",
    //           // 30
    //           "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A87129e56-d617-43e6-9f10-3fa4b2bbdcc9%22%7D%5D%7D",
    //           // 53
    //           "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3A3e102263-cf47-4a3c-83a9-be6c587abcd3%22%7D%5D%7D",
    //           //77
    //           "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ace7758d3-9944-4600-87a7-e503246154dd%22%7D%5D%7D",
    //           //82
    //           "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ade813c76-7a3f-4236-8ca4-a8c7e98f1fd1%22%7D%5D%7D",
    //           //83
    //           "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/wells/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Amaster-data--Well%3Ac718e23c-ab1c-429a-8f0c-ab9c65987f25%22%7D%5D%7D",

    //           "IVAAPMiddleTier:///ivaap/api/ds/opensdublobstorage/v1/sources/8467a79b-0550-447b-a5f9-76a6c34bfccd/seismic/%7B%22tuple%22%3A%5B%7B%22name%22%3A%22dataPartitionId%22%2C%22value%22%3A%22int-chevron-corporation%22%7D%2C%7B%22name%22%3A%22searchDomain%22%2C%22value%22%3A%22osdu%3Awks%22%7D%2C%7B%22name%22%3A%22srn%22%2C%22value%22%3A%22int-chevron-corporation%3Awork-product-component--SeismicTraceData%3A43041ea5-74b7-4e9a-a22f-96f6b1e0027c%22%7D%5D%7D",
    //         ],
    //     type: IVAAPCardType.TEMPLATE,
    //   }
    // };

    const mockVizData = {viz: mockIVAAPResponses[this.currentExample] as any};
    this.currentExample++;
    return of(mockVizData);
  }

  private showMessage(message: string): void {
    this.snackbar.open(message, "Close", {
      duration: 3000,
      horizontalPosition: "end",
      verticalPosition: "top",
    });
  }
}
